import React from 'react';
import CardList from '../cardList/index';
import './style.css';

const Projects = () => {
  return (
    <div className='grid'>
      <CardList />
    </div>
  );
};

export default Projects;
